/* ============================================================
   AMARA — drawers, cart, saved items, gallery
   No dependencies. Everything degrades to a normal page load.
   ============================================================ */
(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $("#Toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("on"); }, 2800);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(sel) {
    var d = $(sel);
    if (!d) return;
    if (!document.querySelector(".drawer.on")) lastFocus = document.activeElement;
    $$(".drawer").forEach(function (x) {
      if (x !== d) { x.classList.remove("on"); x.setAttribute("aria-hidden", "true"); }
    });
    d.classList.add("on");
    d.setAttribute("aria-hidden", "false");
    var sc = $("#Scrim");
    if (sc) sc.classList.add("on");
    document.body.style.overflow = "hidden";
    var f = d.querySelector("input, textarea, button, a[href]");
    if (f) setTimeout(function () { f.focus(); }, 380);
  }
  function closeDrawers() {
    var was = document.querySelector(".drawer.on");
    $$(".drawer").forEach(function (d) { d.classList.remove("on"); d.setAttribute("aria-hidden", "true"); });
    var sc = $("#Scrim");
    if (sc) sc.classList.remove("on");
    document.body.style.overflow = "";
    if (was && lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  /* ---------- saved items (this browser only) ---------- */
  function readWish() {
    try { return JSON.parse(localStorage.getItem("amara.wish") || "[]"); }
    catch (e) { return []; }
  }
  function writeWish(a) { try { localStorage.setItem("amara.wish", JSON.stringify(a)); } catch (e) {} }
  function paintWish() {
    var list = readWish();
    $$("[data-wish-count]").forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle("hide", list.length === 0);
    });
    $$("[data-wish]").forEach(function (b) {
      var on = list.indexOf(b.getAttribute("data-wish")) > -1;
      b.classList.toggle("on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  /* ---------- cart ---------- */
  function refreshCart() {
    return fetch(root + "?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-cart-contents]");
        var here  = $("[data-cart-contents]");
        if (fresh && here) here.innerHTML = fresh.innerHTML;
        var c = doc.querySelector("[data-cart-count]");
        if (c) {
          $$("[data-cart-count]").forEach(function (el) {
            el.textContent = c.textContent;
            el.classList.toggle("hide", c.textContent.trim() === "0");
          });
        }
      });
  }
  function addToCart(id, qty, btn) {
    if (btn) btn.setAttribute("aria-busy", "true");
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(refreshCart)
      .then(function () { openDrawer("#CartDrawer"); })
      .catch(function () { window.location.href = root + "cart"; })
      .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
  }
  function changeLine(key, qty) {
    return fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshCart);
  }

  /* ---------- one delegated click handler ---------- */
  document.addEventListener("click", function (e) {
    var el;

    if ((el = e.target.closest("[data-drawer-open]"))) {
      e.preventDefault(); openDrawer(el.getAttribute("data-drawer-open")); return;
    }
    if (e.target.closest("[data-drawer-close]") || e.target.id === "Scrim") {
      closeDrawers(); return;
    }
    if ((el = e.target.closest("[data-wish]"))) {
      e.preventDefault();
      var h = el.getAttribute("data-wish");
      var list = readWish();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      writeWish(list); paintWish(); return;
    }
    if ((el = e.target.closest("[data-quick-add]"))) {
      e.preventDefault();
      if (el.disabled) return;
      addToCart(el.getAttribute("data-quick-add"), 1, el); return;
    }
    if ((el = e.target.closest("[data-line-change]"))) {
      e.preventDefault();
      changeLine(el.getAttribute("data-line-key"), parseInt(el.getAttribute("data-line-change"), 10));
      return;
    }
    if ((el = e.target.closest("[data-acc]"))) {
      e.preventDefault(); el.parentNode.classList.toggle("open"); return;
    }
    if ((el = e.target.closest("[data-qty]"))) {
      var input = el.parentNode.querySelector("input");
      var v = parseInt(input.value, 10) || 1;
      v += el.getAttribute("data-qty") === "up" ? 1 : -1;
      input.value = Math.max(1, v);
      return;
    }
    if (e.target.closest("[data-sticky-add]")) {
      e.preventDefault();
      var form = $("[data-product-form]");
      if (form) {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      }
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeDrawers(); return; }
    if (e.key !== "Tab") return;
    var d = document.querySelector(".drawer.on");
    if (!d) return;
    var f = $$('a[href], button:not([disabled]), input, textarea, select', d)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- product gallery ----------
     Shows every photo, however many there are. The thumbnail rail scrolls,
     the stage has arrows, swipe and arrow keys, and a counter says where you are.
     Variant changes call gallery.showMedia(id) to jump to that variant's photo. */
  var gallery = (function () {
    var gal = $("[data-gallery]");
    if (!gal) return null;
    var stage = $("[data-stage]", gal);
    var thumbs = $$("[data-shot]", gal);
    var counter = $("[data-gcount]", gal);
    var rtl = document.documentElement.getAttribute("dir") === "rtl";
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var cur = 0;

    thumbs.forEach(function (t, i) { if (t.classList.contains("on")) cur = i; });

    function preload(i) {
      if (i < 0 || i >= thumbs.length) return;
      var im = new Image();
      im.src = thumbs[i].getAttribute("data-shot");
    }

    function reveal(btn) {
      var box = btn.parentNode;           /* the scrolling .thumbs */
      var r = box.getBoundingClientRect(), b = btn.getBoundingClientRect();
      var dy = 0, dx = 0;
      if (box.scrollHeight > box.clientHeight + 1) {
        if (b.top < r.top) dy = b.top - r.top;
        else if (b.bottom > r.bottom) dy = b.bottom - r.bottom;
      }
      if (box.scrollWidth > box.clientWidth + 1) {
        if (b.left < r.left) dx = b.left - r.left;
        else if (b.right > r.right) dx = b.right - r.right;
      }
      if (!dx && !dy) return;
      /* short hops glide; a long jump (colour change deep in a big gallery) goes straight there */
      var far = Math.abs(dy) > box.clientHeight * 1.5 || Math.abs(dx) > box.clientWidth * 1.5;
      box.scrollBy({ left: dx, top: dy, behavior: (reduced || far) ? "auto" : "smooth" });
    }

    function show(i) {
      if (!thumbs.length) return;
      i = (i + thumbs.length) % thumbs.length;       /* wrap around */
      cur = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle("on", on);
        if (on) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current");
      });
      var img = $("img", stage);
      var src = thumbs[i].getAttribute("data-shot");
      if (img && img.getAttribute("src") !== src) {
        img.classList.add("is-swapping");
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
        img.alt = thumbs[i].getAttribute("data-alt") || img.alt;
        img.onload = img.onerror = function () { img.classList.remove("is-swapping"); };
        img.src = src;
        if (img.complete) img.classList.remove("is-swapping");
      }
      if (counter) counter.textContent = (i + 1) + " / " + thumbs.length;
      reveal(thumbs[i]);
      preload(i + 1); preload(i - 1);
    }

    function showMedia(id) {
      for (var i = 0; i < thumbs.length; i++) {
        if (String(thumbs[i].getAttribute("data-media-id")) === String(id)) { show(i); return true; }
      }
      return false;
    }

    gal.addEventListener("click", function (e) {
      var nav = e.target.closest("[data-gnav]");
      if (nav) { e.preventDefault(); show(cur + parseInt(nav.getAttribute("data-gnav"), 10)); return; }
      var t = e.target.closest("[data-shot]");
      if (t) { e.preventDefault(); show(thumbs.indexOf(t)); }
    });

    gal.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var forward = (e.key === "ArrowRight") !== rtl;
      show(cur + (forward ? 1 : -1));
      if (document.activeElement && document.activeElement.hasAttribute("data-shot")) thumbs[cur].focus({ preventScroll: true });
    });

    /* swipe on the stage */
    var x0 = null, y0 = null;
    stage.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      show(cur + ((dx < 0) !== rtl ? 1 : -1));
    }, { passive: true });

    if (thumbs.length) { if (counter) counter.textContent = (cur + 1) + " / " + thumbs.length; preload(cur + 1); }
    return { show: show, showMedia: showMedia, enabled: gal.getAttribute("data-variant-images") !== "false" };
  })();

  /* ---------- product form ---------- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    var idField = form.querySelector("[name='id']");
    if (!idField || !idField.value) return;
    e.preventDefault();
    var qtyField = form.querySelector("[name='quantity']");
    addToCart(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1, form.querySelector("[data-add]"));
  });

  /* ---------- variant picker ---------- */
  $$("[data-variant-picker]").forEach(function (form) {
    var node = form.querySelector("[data-variant-json]");
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent); } catch (err) { return; }
    var idInput = form.querySelector("[name='id']");
    var priceEl = form.querySelector("[data-price]");
    var btn = form.querySelector("[data-add]");
    var lastMedia = null, firstRun = true;

    function update() {
      var chosen = $$("[data-option-value].on", form).map(function (b) {
        return b.getAttribute("data-option-value");
      });
      var match = null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] && v.options[j] !== chosen[j]) ok = false;
        }
        if (ok) { match = v; break; }
      }
      if (!match) return;
      if (idInput) idInput.value = match.id;
      var mid = match.media_id == null ? "" : String(match.media_id);
      if (mid !== lastMedia) {
        lastMedia = mid;
        if (mid && gallery && gallery.enabled && !firstRun) gallery.showMedia(mid);
      }
      if (!firstRun && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", match.id);
          history.replaceState(null, "", u.toString());
        } catch (err) {}
      }
      firstRun = false;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available
          ? btn.getAttribute("data-label-add")
          : btn.getAttribute("data-label-sold");
      }
    }
    form.addEventListener("click", function (e) {
      var b = e.target.closest("[data-option-value]");
      if (!b) return;
      e.preventDefault();
      $$("[data-option-value]", b.parentNode).forEach(function (x) { x.classList.remove("on"); });
      b.classList.add("on");
      var grp = b.closest(".optgroup");
      var cur = grp && grp.querySelector("[data-opt-current]");
      if (cur) cur.textContent = b.getAttribute("data-option-value");
      update();
    });
    update();
  });

  /* ---------- localization selects submit themselves ---------- */
  $$("[data-localization] select").forEach(function (sel) {
    sel.addEventListener("change", function () { if (sel.form) sel.form.submit(); });
  });

  /* ---------- motion ---------- */
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var items = $$(".rv");
  if (reduced || !("IntersectionObserver" in window)) {
    items.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -5% 0px", threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
    requestAnimationFrame(function () {
      items.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.94) el.classList.add("in");
      });
    });
  }

  var last = 0;
  window.addEventListener("scroll", function () {
    var y = window.scrollY || 0;
    if ((y > 40) !== (last > 40)) document.body.classList.toggle("scrolled", y > 40);
    var sticky = $("#StickyBuy");
    if (sticky) sticky.classList.toggle("on", y > 420);
    last = y;
  }, { passive: true });

  /* ---------- announcement rotation ---------- */
  var bar = $("#Announcement");
  if (bar) {
    var msgs = $$("[data-announce]", bar);
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove("on");
        i = (i + 1) % msgs.length;
        msgs[i].classList.add("on");
      }, 5200);
    }
  }

  paintWish();
  window.AmaraCart = { refresh: refreshCart };
  window.AmaraToast = toast;
})();
